import { tariffBuyCustomTitle } from 'reactApp/appHelpers/featuresHelpers';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { useBuyTitle } from 'reactApp/ui/TariffBuy/useBuyTitle';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

import type { BuyIframeQueryParams } from './Buy';

const { title: titleFromQuery }: BuyIframeQueryParams = getQueryParams();

export const useTitle = ({ isPhone, product, isWebview }) => {
    const buyTitle = useBuyTitle({
        product,
        isMobile: isWebview || isPhone,
    });

    if (titleFromQuery && tariffBuyCustomTitle?.hasOwnProperty(titleFromQuery)) {
        return tariffBuyCustomTitle[titleFromQuery];
    }

    // для облачного вебвью возвращает title как в старом окне
    if (isWebview && buyTitle) {
        return buyTitle;
    }

    if (isPhone && product) {
        const { discountPrice, discountPeriod, period, space, price, hasTrial, trialPeriod } = product || {};

        const priceText = hasTrial ? 'бесплатно' : ` за ${formatPrice(discountPrice || price)} ₽`;

        return `Отключение рекламы\nи ${space.value} на ${getPeriodName(
            trialPeriod || discountPeriod || period,
            false,
            true
        )} ${priceText}`;
    }

    return 'Никакой рекламы и больше места в Почте и Облаке';
};
